export enum PolyEventName {
	POLY_PROGRESS = 'POLYProgress',
	// scene
	SCENE_CREATED = 'POLYSceneCreated',
	SCENE_READY = 'POLYSceneReady',
	SCENE_PLAY = 'POLYScenePlay',
	SCENE_PAUSE = 'POLYScenePause',
	// viewer
	VIEWER_MOUNTED = 'POLYViewerMounted',
	VIEWER_READY = 'POLYViewerReady',
}
